<template>
  <div class="input-group input-group-outline mb-3">
    <label class="form-label">Código</label>
    <input
      type="text"
      :value="maskedCode"
      maxlength="11"
      class="form-control"
      @input="onInput"
      @paste="onPaste"
    />
  </div>
</template>

<script>
export default {
  name: "app-input-code",
  props: {},
  data() {
    return {
      code: "", // valor limpo (sem traços)
    };
  },
  computed: {
    maskedCode() {
      // aplica a máscara
      const chars = this.code.replace(/[^0-9a-zA-Z]/gi, "").slice(0, 6);
      return chars.split("").join("-");
    }
  },
  methods: {
    emitCode() {
      // emite o valor limpo (sem traços)
      this.$emit("input", this.code);
    },
    onInput(e) {
      let value = e.target.value.replace(/[^0-9a-zA-Z]/gi, "").slice(0, 6);
      this.code = value;
      this.emitCode();
    },
    onPaste(e) {
      e.preventDefault();
      let clipboardData = (e.clipboardData || window.clipboardData).getData("text");
      let value = clipboardData.replace(/[^0-9a-zA-Z]/gi, "").slice(0, 6);
      this.code = value;
      this.emitCode();
    }
  }
};
</script>